import { CapacitorConfig } from '@capacitor/cli';

const config: CapacitorConfig = {
  appId: 'com.bomaid.vivascore',
  appName: 'Thrive',
  webDir: 'www/browser',
  loggingBehavior: 'production',

  server: {
    errorPath: '/'
  },
  plugins: {
    SplashScreen: {
      launchAutoHide: true,
      launchShowDuration: 10000,
      androidSplashResourceName: "splash",
      androidScaleType: "CENTER_CROP",
      backgroundColor: "#000000",
      splashFullScreen: true,
      splashImmersive: true,
      useDialog: false
    },
    Keyboard: {
      resizeOnFullScreen: true   // 👈 important for Android
    }
  },

  ios: {
    scheme: 'bomaid',
    handleApplicationNotifications: false
  },

  android: {
    flavor: 'bomaid',
    loggingBehavior: 'none'
  }
};

export default config;
